import React from 'react'
import { BsTelephone } from 'react-icons/bs'
import { AiOutlineMail } from 'react-icons/ai'
import { GoLocation } from 'react-icons/go'
import './style.css'

export default function Footer() {
  return (
    <>
      <footer>
        <div className="w-full foot -bg-white row">
          <div className="col-lg-3 text-center resection merci">
            <h2>Havoo</h2>
            <p className="font-normal">
              C'est une entreprise africaine qui propose des services a la
              demande aux personnes desireuses de profiter de leur vie.
            </p>
          </div>
          <div className="col-lg-3 ml-auto flex flex-col p-3">
            <h3 className="text-xl  font-bold">Informations de contact</h3>
            <ul className="mt-3">
              <li className="flex  align-items-center  gap-1">
                <ion-icon name="call-sharp"></ion-icon>{' '}
                <p className="text-md"> +221 77 749 39 10 </p>
              </li>
              <li className="flex  align-items-center  gap-1">
                {' '}
                <ion-icon name="mail-sharp"></ion-icon>{' '}
                <p className="text-md"> marvinndg242@gmail.com</p>
              </li>

              <li className="flex  align-items-center  gap-1">
                <ion-icon name="location-sharp"></ion-icon>{' '}
                <p className="text-md"> Parc amazout,Colobane,Dakar </p>
              </li>
            </ul>
          </div>

          <div className="bottomFooter ">
            <div className="flex flex-wrap  copyright text-black-50  gap-2">
              <p className="text-sm text-black">2022 © Havoo</p>
              <p className="text-sm"> - </p>

              <a href="/condition" className="lg:text-sm text-black">
                Conditions d'utilisations
              </a>
              <p className="text-sm"> - </p>
              <a href="/politique" className="lg:text-sm text-black">
                Politique de confidentialite
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
